import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { TENANT_LANG_LS_KEY } from "@lib/tenantPersistKeys";
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "./languages";
import { buildResources } from "./resources";

const modules = import.meta.glob("./locales/*/*.json", { eager: true, import: "default" });
const resources = buildResources(modules);

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: Object.fromEntries(
            SUPPORTED_LANGUAGES.map((l) => [l.code, { translation: resources[l.code] }])
        ),
        fallbackLng: DEFAULT_LANGUAGE,
        supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: TENANT_LANG_LS_KEY,
        },
    });

export default i18n;
